import type { RecursiveCSS } from "../theme/GlobalTheme";

export const BUTTON_TRANSITION = "background-color 180ms ease, border-color 180ms ease, color 180ms ease, box-shadow 180ms ease, transform 180ms ease";
const hoverShadow = "inset 0 0 0 999px rgba(23, 36, 59, .06)";
const activeShadow = "inset 0 0 0 999px rgba(23, 36, 59, .12)";

// Layout and semantic base colors belong to the caller; interaction belongs here.
// Normalize nested responsive rules too so they cannot reintroduce local motion.
export function buttonStates(styles: RecursiveCSS): RecursiveCSS {
	const base: Record<string, unknown> = {};
	for (const [key, value] of Object.entries(styles)) {
		if (/:(hover|active|disabled|focus-visible)/.test(key) || ["transition", "transform", "filter", "boxShadow"].includes(key)) continue;
		base[key] = value && typeof value === "object" && key.startsWith("@")
			? cleanResponsive(value as Record<string, unknown>)
			: value;
	}
	return {
		...base,
		boxShadow: "none",
		transform: "none",
		transition: BUTTON_TRANSITION,
		"@media (hover: hover) and (pointer: fine)": {
			"&:hover:not(:disabled):not([aria-disabled='true']):not(:active)": { boxShadow: hoverShadow, transform: "none" },
		} as RecursiveCSS,
		"&:active:not(:disabled):not([aria-disabled='true'])": { boxShadow: activeShadow, transform: "scale(.98)" },
		"&:focus-visible": { outline: "3px solid #8C88F3", outlineOffset: "3px" },
		"&:disabled, &[aria-disabled='true']": { opacity: .55, cursor: "not-allowed", boxShadow: "none", transform: "none" },
		"@media (prefers-reduced-motion: reduce)": {
			transition: "none !important",
			"&:active:not(:disabled):not([aria-disabled='true'])": { transform: "none !important" },
		} as RecursiveCSS,
	};
}

function cleanResponsive(styles: Record<string, unknown>): Record<string, unknown> {
	return Object.fromEntries(Object.entries(styles)
		.filter(([key]) => !/:(hover|active|disabled|focus-visible)/.test(key) && !["transition", "transform", "filter", "boxShadow"].includes(key))
		.map(([key, value]) => [key, value && typeof value === "object" ? cleanResponsive(value as Record<string, unknown>) : value]));
}
